import React, { Component, Suspense } from "react";
import TablesData from "./TablesData.js";
import SubTable from "../../../Components/DataTableSimple/index.js";
import Map from "../../../Components/Maps/map.js";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Card, CardBody } from "reactstrap";

const CardResumen = React.lazy(() => import("../../../Components/CardResumenShare/index.js"));
const StatusInfo = React.lazy(() => import("./StatusInfo.js"));

class SumaryDetail extends Component {
  state = {
    FechaActualizacion: "",
    ShipmentNumber: "",
    Progress: 1,
    HBL_HAWB: "",
    Status: "",
    headers: { title: this.props.t("shipment"), logo: "" },
    data: [],
    dataDrawer: "",
    markers: [],
    polylineData: [],
    visible: true,
    Resumen: [],
    steps: [],
    tables: [],
    shipment: []
  };
  componentDidMount = () => {
    this.setState(
      {
        steps: this.props.steps,
        markers: this.props.markers ? this.props.markers : [],
        polylineData: this.props.polylineData ? this.props.polylineData : [],
        Resumen: this.props.Resumen ? this.props.Resumen : [],
        tables: this.props.tables,
        shipment: this.props.shipment,
        Progress: this.props.shipment ? this.props.shipment.Progress : 1,
        ShipmentNumber: this.props.shipment
          ? this.props.shipment.ShipmentNumber
          : "",
        HBL_HAWB: this.props.shipment ? this.props.shipment.HBL_HAWB : "",
        Status: this.props.shipment ? this.props.shipment.Status : "",
        TransportPlanNo: this.props.shipment ? this.props.shipment.TransportPlanNo : "",

        TransportMode: this.props.shipment
          ? this.props.shipment.TransportMode
          : "",
        cliente: this.props.shipment ? this.props.shipment.CustomerName : "",
        NIT: this.props.shipment ? this.props.shipment.NIT : "",
        Grupo: this.props.shipment ? this.props.shipment.Grupo : "",
        FechaActualizacion: this.props.shipment
          ? this.props.shipment.FechaActualizacion
          : "",
        PriorityShipment: this.props.shipment
          ? this.props.shipment.PriorityShipment
          : "",
      }
    );
  };

  componentWillReceiveProps = (nextProps) => {

    this.setState(
      {
        steps: nextProps.steps,
        markers: nextProps.markers,
        polylineData: nextProps.polylineData,
        Resumen: nextProps.Resumen,
        tables: nextProps.tables,
        shipment: nextProps.shipment,
        Progress: nextProps.shipment ? nextProps.shipment.Progress : 1,
        ShipmentNumber: nextProps.shipment
          ? nextProps.shipment.ShipmentNumber
          : "",
        TransportPlanNo: nextProps.shipment
          ? nextProps.shipment.TransportPlanNo
          : "",

        HBL_HAWB: nextProps.shipment ? nextProps.shipment.HBL_HAWB : "",
        Status: nextProps.shipment ? nextProps.shipment.Status : "",

        TransportMode: nextProps.shipment
          ? nextProps.shipment.TransportMode
          : "",
        cliente: nextProps.shipment ? nextProps.shipment.CustomerName : "",
        NIT: nextProps.shipment ? nextProps.shipment.NIT : "",
        Grupo: nextProps.shipment ? nextProps.shipment.Grupo : "",
        FechaActualizacion: nextProps.shipment
          ? nextProps.shipment.FechaActualizacion
          : "",
        PriorityShipment: nextProps.shipment
          ? nextProps.shipment.PriorityShipment
          : "",
      }
    );
  };


  render() {
    let {
      dataDrawer,
      ShipmentNumber,
      HBL_HAWB,
      Status,
      markers,
      TransportPlanNo,
      polylineData,
      TransportMode,
      tables,
      Resumen,
      headers,
      shipment
    } = this.state;

    return (
      <>
        <div className="row">
          <div className="col-12" >
            <Suspense fallback={<div>Loading...</div>}>
              <StatusInfo
                Progress={this.state.Progress}
                FechaActualizacion={this.state.FechaActualizacion}
                PriorityShipment={this.state.PriorityShipment}
                cliente={this.state.cliente}
                NIT={this.state.NIT}
                Grupo={this.state.Grupo}
                steps={this.state.steps}
                ModoTransporte={TransportMode}
                shipmentData={shipment}
                DoEmbarque={ShipmentNumber}
                TransportPlanNo={TransportPlanNo}
                HBL_HAWB={HBL_HAWB}
                Estatus={Status}
                infoEmbarque={this.state.infoEmbarque}
                shipment={"shipment"}
                shipmentDataPlane={"shipmentDataPlane"}
                POId={"POId"}
              />
            </Suspense>
          </div>
          <div className="col-xs-12 col-md-9 col-lg-8 d-flex flex-column">
            <Suspense fallback={<div>Loading...</div>}>
              <CardResumen
                shipment={this.state.shipment}
                ModoTransporte={TransportMode}
                headers={headers}
                data={Resumen}
              />
            </Suspense>
          </div>

          <div className="col-xs-12 col-md-3 col-lg-4 d-flex flex-column">
            <Card className="mapCard myCard">
              <div className="map-container">
                <Map
                  heidIcon={20}
                  marker={markers}
                  visible={true}
                  type={"polyline"}
                  data={polylineData}
                  dataDrawer={dataDrawer}
                />
              </div>
            </Card>
          </div>


          <div className="col-12" >
            <div className="row">
              <div className="col-12">
                <div >
                  {tables.map((e, index) => {
                    if (!e.data || e.data.length <= 0) return false;
                    else {
                      let defaultData = [];
                      if (e.data.length === 1 && Object.keys(e.data[0]).length !== 0) {
                        defaultData = e.data;
                      } else if (e.data.length > 1) {
                        defaultData = e.data;
                      }
                      return e.key === "Waybill" || e.key === "PO" ? (
                        <Card className="myCard">
                          <CardBody>
                            <legend className="titleCardResumen">
                              {e.title}
                            </legend>
                            <SubTable
                              data={defaultData}
                              columnsTable={e.columnsTable ? e.columnsTable : []}
                              subTable={e.subTable ? e.subTable : []}
                              subHeader={e.subHeader ? e.subHeader : <></>}
                            ></SubTable>
                          </CardBody>
                        </Card>
                      ) : (
                        <TablesData
                          style={{ width: "100%" }}
                          columns={e.columns}
                          subTable={e.subTable}
                          data={e.data}
                          key={index}
                          startSubTable={1}
                          itemsByPage={10}
                          title={e.title}
                          keyvalue={e.key}
                          options={{
                            pagination: false,
                            search: false,
                            downloads: {
                              xlsx: false,
                              pdf: false,
                            },
                          }}
                        />
                      );
                      // }
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withNamespaces()(withRouter(SumaryDetail));
